exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sprite-name[data-v-9f69594e]{margin-left:2rem;font-size:1.1rem;padding-top:.2rem}.sprite-selector[data-v-9f69594e]  .multiselect__single{margin-bottom:5px}.sprite-selector[data-v-9f69594e]  .multiselect__option{line-height:24px}.sprite-selector[data-v-9f69594e]  .multiselect__tags{border:none;padding-top:7px}", ""]);

// exports
